import { createSelector } from "@reduxjs/toolkit"; 
import { RootState } from "types";
import { initialState } from "./initialState";

const getAdminManagementState = (state: RootState) =>
  state.adminMangmentState
    ? { ...initialState, ...state.adminMangmentState }
    : initialState;

export { getAdminManagementState };

export const selectStatusFilter = createSelector(
    [getAdminManagementState],
    (adminManagementState) => adminManagementState.statusFilter
);

export const selectFormData = createSelector(
    [getAdminManagementState],
    (adminManagementState) => adminManagementState.newUserForm
);

export const selectData = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.data
);

export const selectIsLoading = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.isLoading
);

export const selectError = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.error
);

export const selectAdminManagementMeta = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.meta
);

export const selectAdminManagementPage = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.page
);

export const selectAdminManagementPerPage = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.perPage
);

export const selectFilteredData = createSelector(
    [selectData, selectStatusFilter],
    (data, statusFilter) =>
        statusFilter === "ALL" ? data : data.filter(item => item.status === statusFilter)
);

export const selectIsAddModalOpen = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.isAddModalOpen
);

export const selectUserDetailes = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState.userDetailes
);
